// The cars in each vehicle class, shown on the home page and the fleet page. Written into the
// pages (not loaded from the API) so the prerendered HTML search engines read includes them.
// Capacities and prices for each class come from prices.json (VEHICLES / HOURLY).
export const FLEET_CARS = [
  { id: 'lyriq', name: 'Cadillac Lyriq', classKey: 'sedan', image: '/images/vehicles/fleet-sedan.webp' },
  { id: 'xt6', name: 'Cadillac XT6', classKey: 'sedan', image: '/images/vehicles/fleet-sedan-xt6.webp' },
  { id: 'vistiq', name: 'Cadillac Vistiq', classKey: 'sedan', image: '/images/vehicles/fleet-sedan-vistiq.webp' },
  { id: 'escalade-esv', name: 'Cadillac Escalade ESV', classKey: 'suv', image: '/images/vehicles/fleet-suv.webp' },
];

export const carsInClass = (classKey) => FLEET_CARS.filter((c) => c.classKey === classKey);

// "Cadillac Lyriq, Cadillac XT6 or Cadillac Vistiq"
export function modelList(classKey) {
  const names = carsInClass(classKey).map((c) => c.name);
  return names.length > 1 ? `${names.slice(0, -1).join(', ')} or ${names[names.length - 1]}` : names[0];
}

export const carAlt = (car, className) => `${car.name} in black, side view – RoolDrive ${className}`;
